// SystemNotification.js
import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";

export default function SystemNotification({ notification }) {
  return (
    <Box
      sx={{
        backgroundColor: "#333",
        color: "#FFEE20",
        padding: "8px 16px",
        borderRadius: "8px",
        marginTop: "8px",
      }}
    >
      <Typography variant="body2">{notification}</Typography>
    </Box>
  );
}
